module.exports = __webpack_public_path__ + "images/sprites/ui/icon_badge_ribon_bu_4098cfa606d3124a76a22906251979b1.png";